const modal = {}

export default modal
